const hrmFrameResize = function () {
  function receiveMessage(event) {
    try {
      var request = JSON.parse(event.data);
    } catch (e) {
      return;
    }

    if (request.action === "resizeMe") {
      const height = parseInt(request.height, 10) + 0;
      document.getElementById("iframeHeightDiv").style.height = height + 100 + "px";
    }
  }

  function bindEvent(window, eventName, eventHandler) {
    if (window.addEventListener) {
      window.addEventListener("message", eventHandler, false);
    } else if (window.attachEvent) {
      window.attachEvent("on" + eventName, eventHandler);
    }
  }

  bindEvent(window, "message", receiveMessage);
};

hrmFrameResize();
